import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";
import moment from 'moment';

export default {
    getOperationEntitiesByGroupForDropDown,
    GetReportDetails,
    getCollectionPointsByOperationentityGroupID,
    getGangByCollectionPointID
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + parseInt(id));
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getGangByCollectionPointID(operationEntityID, collectionPointID) {
    var gangArray = [];
    const response = await CommonGet('/api/Gang/GetGangBySearch', "operationEntityID=" + parseInt(operationEntityID) + '&collectionPointID=' + parseInt(collectionPointID));
    for (let item of Object.entries(response.data)) {
        gangArray[item[1]["gangID"]] = item[1]["gangName"]
    }
    return gangArray;
}

async function GetReportDetails(operationEntityID, collectionPointID, gangID, employeeTypeID, year) {
    var newModel = {
        operationEntityID: parseInt(operationEntityID),
        collectionPointID: parseInt(collectionPointID),
        gangID: parseInt(gangID),
        employeeTypeID: employeeTypeID,
        year: year.toISOString()
    }
    const response = await CommonPost('/api/AnnualLabourAttendanceMonitoringAverageReport/GetAnnualLabourAttendanceMonitoringAverageReportService', null, newModel);
    return response.data;
}

